export const recipeToMacroMap = recipe => {
	const totalsMap = {
		carbs:{
			qty:0,
			unit:'g'
		},
		protein:{
			qty:0,
			unit:'g'
		},
		calories:{
			qty:0,
			unit:'kcal'
		},
		fat:{
			qty:0,
			unit:'g'
		},
		sodium:{
			qty:0,
			unit:'g'
		},
		fiber:{
			qty:0,
			unit:'g'
		}
	}

	if (!Boolean(recipe)) return totalsMap

	//total the standard macros from foods
	recipe.foods.filter(({type})=>type!=='placeholder').forEach(({food,quantity,food_db_portion_id})=>{
		if (food.type === 'placeholder') return 

		if(!food.portions) return totalsMap

		const portion = food.portions.find(({id})=>(
			id === food_db_portion_id
		)) || food.portions[0]

		totalsMap.calories.qty += quantity * portion.calories
		totalsMap.protein.qty += quantity * portion.protein
		totalsMap.fat.qty += quantity * portion.fat
		totalsMap.carbs.qty += quantity * portion.carbs
		totalsMap.sodium.qty += quantity * portion.sodium
		totalsMap.fiber.qty += quantity * portion.fiber
		return totalsMap
	})

	//total custom macros
	if (Boolean(recipe.use_custom_macros)&&Boolean(recipe.macros)) {
		recipe.macros.forEach(({macro,qty,unit})=>{
			//use lower case so that if a user defined something like
			//Carbs as a custom macro it will still total correctly 
			//with the all carbs
			macro = macro.toLowerCase().trim()
			if(!totalsMap[macro]){
				totalsMap[macro] = {qty:0,unit}
			}
			totalsMap[macro].qty+=parseFloat(qty)
		})
	}

	return totalsMap
}


const MacroTotals = ({recipe,align="center"})=>{
	const macroMap = recipeToMacroMap(recipe)
	//if no macros display nothing
	if (Object.entries(macroMap).filter(([_,{qty}])=>qty>0).length === 0) return null
	//else display those macros with values greather than 0
	return (
		<div className={`text-${align}`}>
			<small>
				<strong className="mr-1">Macro Totals:</strong>
				{
					Object.entries(macroMap)
						.filter(([_,{qty}])=>qty>0)
						.map(([macro,{qty,unit}])=>`${macro}: ${qty}${unit}`).join(' | ')
				}
			</small>
		</div>
	)
}

export default MacroTotals